export const VIEW_TYPES = {
  MONTH: 'month',
  WEEK: 'week',
};

export const VIEW_TYPES_TEXT = {
  [VIEW_TYPES.MONTH]: 'Месяц',
  [VIEW_TYPES.WEEK]: 'Неделя',
};

export const USER_TYPES = {
  GUEST: '1',
  USER: '2',
  ME: '3',
};

export const USER_TYPES_NAMES = {
  [USER_TYPES.GUEST]: 'Гость',
  [USER_TYPES.USER]: 'Пользователь',
  [USER_TYPES.ME]: 'Я',
};
